import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withFirebase, withFirestore } from 'react-redux-firebase';
import { Button } from 'reactstrap';
import WithLoader from 'components/WithLoader';
import User from './User';
import { actions as accountActions } from 'reducers/account';
import { actions as fetchingActions } from 'reducers/fetching';
import * as roles from 'constants/roles';

class Dispatchers extends User {
  static defaultProps = {
    role: 'dispatcher'
  }

  getAccounts() {
    const dispatchers = this.props.users.filter(u => ([roles.DISPATCHER, roles.ADMIN].includes(u.role)) && !u.disabled);
    return dispatchers;
  }

  getNewAccountButton() {
    return <Button color="primary" onClick={() => this.showAccount()}>New Employee</Button>;
  }
}

const mapStateToProps = ({ account, firestore: { ordered }, fetching: { isLoading } }) => {
  return {
    account,
    isLoading,
  };
};

const mapDispatchToProps = ({
  ...accountActions,
  ...fetchingActions,
});

const FirestoreConnected = compose(
  withFirebase,
  withFirestore,
  connect(mapStateToProps, mapDispatchToProps),
)(Dispatchers);

export default WithLoader(FirestoreConnected);
